/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
import './device';
import './device_profile_type';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "shared": {
                        "nested": {
                          "DeviceProfileLink": {
                            "fields": {
                              "device": {
                                "type": ".squareup.devicesettings.profiles.v2.model.shared.Device",
                                "id": 1,
                                "rule": "optional"
                              },
                              "deviceProfileId": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "deviceProfileType": {
                                "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                                "id": 3,
                                "rule": "optional"
                              },
                              "deviceProfileName": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.shared?.nested?.DeviceProfileLink) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceProfileLink @ squareup/devicesettings/profiles/v2/model/shared/device_profile_link.proto at 13:1
 */
export const DeviceProfileLink = $root.lookupType('squareup.devicesettings.profiles.v2.model.shared.DeviceProfileLink');
fixType(DeviceProfileLink, {
  device: {
    required: true
  },
  deviceProfileId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DeviceProfileLink);